import { render } from "./EditarPerfil.vue?vue&type=template&id=40404838"
import script from "./EditarPerfil.vue?vue&type=script&lang=js"
export * from "./EditarPerfil.vue?vue&type=script&lang=js"

import "./EditarPerfil.vue?vue&type=style&index=0&id=40404838&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__